/* Izela Image Cards — edge color sampler.
   For cards using the "Match photo edge color" style, loads the small CDN
   thumbnail, samples the border ring of pixels, and sets the median color
   as the card background. Uniform studio backdrops (white, tan, grey)
   extend invisibly. Transparent pixels are ignored; if the ring is mostly
   transparent (PNG cutouts), the fallback flat color is kept.
   Also verifies flat-filled PNG cards: opaque PNGs (regular photos saved
   as .png) are reclassified to the normal treatment so only genuine
   transparent cutouts keep the flat fill. */
(function () {
  if (window.__izelaEdge) return;
  window.__izelaEdge = true;
  var SEL = '.izela-fill--edge[data-iz-thumb]';
  var PSEL = '[data-iz-png-check]';

  function median(a) {
    a.sort(function (p, q) { return p - q; });
    return a[a.length >> 1];
  }

  function sample(el) {
    if (el.dataset.izDone) return;
    el.dataset.izDone = '1';
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var s = 32;
        var c = document.createElement('canvas');
        c.width = s; c.height = s;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(img, 0, 0, s, s);
        var d = x.getImageData(0, 0, s, s).data;
        var rs = [], gs = [], bs = [];
        for (var j = 0; j < s; j++) {
          for (var i = 0; i < s; i++) {
            if (i > 2 && i < s - 3 && j > 2 && j < s - 3) continue; /* border ring only */
            var k = (j * s + i) * 4;
            if (d[k + 3] < 200) continue; /* skip transparent */
            rs.push(d[k]); gs.push(d[k + 1]); bs.push(d[k + 2]);
          }
        }
        if (rs.length < 40) return; /* mostly transparent ring: keep fallback color */
        el.style.backgroundColor = 'rgb(' + median(rs) + ',' + median(gs) + ',' + median(bs) + ')';
      } catch (e) { /* keep fallback color */ }
    };
    img.src = el.dataset.izThumb;
  }

  function pngCheck(el) {
    if (el.dataset.izPngDone) return;
    el.dataset.izPngDone = '1';
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var s = 32;
        var c = document.createElement('canvas');
        c.width = s; c.height = s;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(img, 0, 0, s, s);
        var d = x.getImageData(0, 0, s, s).data;
        var clear = 0;
        for (var k = 3; k < d.length; k += 4) {
          if (d[k] < 250) {
            clear++;
            if (clear > 12) return; /* genuine cutout: keep the flat fill */
          }
        }
        /* Opaque PNG: hand the card back to the normal treatment */
        var fb = el.dataset.izFallback || 'blur';
        if (fb === 'crop') {
          el.className = 'izela-blur-bg izela-fill--crop';
          el.style.backgroundColor = '';
        } else if (fb === 'edge') {
          el.className = 'izela-blur-bg izela-fill--flat izela-fill--edge';
          sample(el);
        } else {
          el.className = 'izela-blur-bg';
          el.style.backgroundColor = '';
          el.style.backgroundImage = "url('" + el.dataset.izBlur + "')";
        }
      } catch (e) { /* keep the flat fill */ }
    };
    img.src = el.dataset.izThumb;
  }

  function run() {
    document.querySelectorAll(SEL).forEach(sample);
    document.querySelectorAll(PSEL).forEach(pngCheck);
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; run(); });
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  /* Re-run when Dawn swaps grid content (filters, pagination, quick views) */
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
